import { Helmet } from 'react-helmet-async';

type JsonLdData = Record<string, unknown>;

interface JsonLdProps {
  data: JsonLdData | JsonLdData[];
}

export function JsonLd({ data }: JsonLdProps) {
  const items = Array.isArray(data) ? data : [data];
  return (
    <Helmet>
      {items.map((item, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(item)}
        </script>
      ))}
    </Helmet>
  );
}

const BASE_URL = 'https://dostash.com';

export function websiteJsonLd(): JsonLdData {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'DoStash',
    url: `${BASE_URL}/`,
    description:
      'Save, organize, and share links, videos, and images in a private collection. No sign-up, no cookies, no tracking. Create your free stash in seconds.',
  };
}

export function breadcrumbJsonLd(
  items: { name: string; path: string }[]
): JsonLdData {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      item: `${BASE_URL}${item.path}`,
    })),
  };
}
